import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useCart } from './CartContext';
import './rice.css';

const products = [
  { name: 'Urad Dal Black Split', image: '/images/lentils/uradblack.webp', link: '/lentils/uraddalblacksplit' },
  { name: 'Urad Dal White Full', image: '/images/lentils/uradwhitefull.webp', link: '/lentils/uraddalwhitefull' },
  { name: 'Urad Dal White Split', image: '/images/lentils/uradwhite.webp', link: '/lentils/uraddalwhitesplit' },
  { name: 'Toor Dal', image: '/images/lentils/toor.webp', link: '/lentils/toordal' },
  { name: 'Moong Peas Green Full', image: '/images/lentils/moonggreen.webp', link: '/lentils/moongpeasgreenfull' },
  { name: 'Moong Dal Yellow Split', image: '/images/lentils/moongyellow.webp', link: '/lentils/moongdalyellowsplit' },
  { name: 'Masoor Red Dal', image: '/images/lentils/masoor.webp', link: '/lentils/masoorreddal' },
  { name: 'Roasted Channa Whole', image: '/images/lentils/channawhole.webp', link: '/lentils/roastedchannawhole' },
  { name: 'Roasted Channa Split', image: '/images/lentils/chennasplit.webp', link: '/lentils/roastedchannasplit' },
  { name: 'Chickpeas Black', image: '/images/lentils/chickpeasblack.webp', link: '/lentils/chickpeasblack' },
  { name: 'Chickpeas White', image: '/images/lentils/chickpeaswhite.webp', link: '/lentils/chickpeaswhite' },
  { name: 'Black Eyed Peas Brown', image: '/images/lentils/peasbrown.webp', link: '/lentils/blackeyedpeasbrown' },
  { name: 'Black Eyed Peas White', image: '/images/lentils/peaswhite.webp', link: '/lentils/blackeyedpeaswhite' },
  { name: 'Lima Beans-white', image: '/images/lentils/beanswhite.webp', link: '/lentils/limabeanswhite' },
  { name: 'Lima Beans-black', image: '/images/lentils/beansblack.webp', link: '/lentils/limabeansblack' },
  { name: 'Tamarind Seed', image: '/images/lentils/tamarind.webp', link: '/lentils/tamarindseedseedless' },
  { name: 'Tamarind Seedless', image: '/images/lentils/tamarindseedless.webp', link: '/lentils/tamarindseedless' },
  { name: 'Channa Dal', image: '/images/lentils/channadall.webp', link: '/lentils/channadal' },
  { name: 'Green Peas', image: '/images/lentils/greanpeas.webp', link: '/lentils/greenpeas' },
  { name: 'White Peas', image: '/images/lentils/whitepeas.webp', link: '/lentils/whitepeas' },
  { name: 'Rajma', image: '/images/lentils/rajma.webp', link: '/lentils/rajmaa' }
];

const qtyOptions = ['250kg', '500g', '1kg', '2kg', '5kg'];

const Oil = () => {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [selectedQty, setSelectedQty] = useState({});

  const [selectedQuantities, setSelectedQuantities] = useState({});

  const handleKnowMore = (link) => {
    navigate(link);
  };

  const goToProducts = () => {
    navigate('/products');
  };

  const toggleQtyType = (productIndex, qtyType) => {
    const productQuantities = selectedQuantities[productIndex] || {};
    const isSelected = qtyType in productQuantities;

    const updated = { ...productQuantities };
    if (isSelected) {
      delete updated[qtyType];
    } else {
      updated[qtyType] = 1;
    }

    setSelectedQuantities({
      ...selectedQuantities,
      [productIndex]: updated,
    });
  };

  const incrementQty = (index, qtyType) => {
    const productQuantities = selectedQuantities[index] || {};
    const currentQty = productQuantities[qtyType] || 1;

    setSelectedQuantities({
      ...selectedQuantities,
      [index]: {
        ...productQuantities,
        [qtyType]: currentQty + 1,
      },
    });
  };

  const decrementQty = (index, qtyType) => {
    const productQuantities = selectedQuantities[index] || {};
    const currentQty = productQuantities[qtyType];

    if (currentQty > 1) {
      setSelectedQuantities({
        ...selectedQuantities,
        [index]: {
          ...productQuantities,
          [qtyType]: currentQty - 1,
        },
      });
    }
  };

  const handleAddToCart = (product, index) => {
    const quantities = selectedQuantities[index];
    if (!quantities || Object.keys(quantities).length === 0) {
      toast.warn("Please select at least one quantity!", { position: "top-right" });
      return;
    }

    Object.entries(quantities).forEach(([qtyType, qtyCount]) => {
      const item = {
        ...product,
        qtyType,
        qtyCount,
      };
      addToCart(item);
      toast.success(`${product.name} (${qtyCount} × ${qtyType}) added to cart`, {
        position: "top-right",
        autoClose: 2000,
      });
    });
  };

  return (
    <section className="rice">
      <div className='border'>
        <img src="/images/border.png" className='border-img' alt="decorative border" />
      </div>
      <h1>Jeyam Lentils Products</h1>
      <div className='border'>
        <img src="/images/border.png" className='border-img' alt="decorative border" />
      </div>
      <button className='back-btn' onClick={goToProducts}>⟵ Back to Products</button>
      <div className="product-grid">
        {products.map((product, index) => (
          <div className="product-card" key={index}>
            <img src={product.image} alt={product.name} />
            <div className="product-name">{product.name}</div>
            <div className="qty-options">
              {qtyOptions.map((qtyType) => {
                const isSelected = selectedQuantities[index]?.[qtyType];

                return (
                  <div key={qtyType} className="qty-select-block">
                    <span
                      className={isSelected ? 'qty selected' : 'qty'}
                      onClick={() => toggleQtyType(index, qtyType)}
                    >
                      {qtyType}
                    </span>
                    {isSelected && (
                      <div className="qty-controls">
                        <button onClick={() => decrementQty(index, qtyType)}>-</button>
                        <span>{selectedQuantities[index][qtyType]}</span>
                        <button onClick={() => incrementQty(index, qtyType)}>+</button>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            <div className="btn-group">
              <button className="know-more" onClick={() => handleKnowMore(product.link)}>
                Know More
              </button>
              <button className="add-cart" onClick={() => handleAddToCart(product, index)}>
                Add to Cart
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className='cart-button'>
        <Link to="/cart">
          <button className='cart-btn'>Go To Cart</button>
        </Link>
      </div>
      <Link to="/cart" className="floating-cart-btn" title="Go to Cart">
        Go to cart 🛒
      </Link>

      <ToastContainer />
    </section>
  );
};

export default Oil;
